<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
  <app-header></app-header>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
  <div class="container-fluid" #main [style.padding-top.px]="paddingtop">
    <div class="col-sm-12 px-0 align-self-end">
      <div class="row align-items-center">
        <div class="col-sm-10">
          <h5 class="light-header bold">
            {{ 'MYACCOUNT.DELETE_PROFILE_LBL_TITLE' | translate}}
          </h5>
        </div>
        <!-- Exit button -->
        <!-- <div class="col-sm-2">
          <button type="button" class="btn btn-primary btn-sm float-right" (click)="exitBtnClickEvent()">
            <i class="fas fa-sign-out"></i> Exit
          </button>
        </div> -->
      </div>
      <hr class="mt-0 mb-3" />
    </div>
    <div class="pt-3">
      <div class="container border rounded p-3 bold col-sm-5">
        <form  [formGroup]="iSForm">



          <div class="form-group row">
            <label for="email" class="col-sm-4 col-form-label">Email</label>
            <div class="col-sm-8">
              <input type="text" class="form-control bold" id="email" autocomplete="off" disabled
                     [(ngModel)]="email" formControlName="email"/>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6 d-flex justify-content-end">
              <button type="button" class="btn btn-primary btn-sm" (click)="deleteBtnClickEvent()"> <i class="far fa-save"></i> Delete</button>
              &nbsp;&nbsp;
              <button type="button" class="btn btn-primary btn-sm" (click)="cancelBtnClickEvent()"> <i class="far fa-times"></i> Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
